export default __webpack_public_path__ + "8b0741ca35b7f535181f466bae2520d3.svg";